var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntrythingy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.92 0 15.84 0 24 0 C24 7.92 24 15.84 24 24 C16.08 24 8.16 24 0 24 C0 16.08 0 8.16 0 0 Z ",
    fill: "#E29436",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.48 0.49 4.96 0.98 7.5 1.5 C5.81 4.96 5.904 8.436 6 12 C9.456 12 12.936 12 16.5 12 C16.5 14.976 16.5 14.976 16.5 16.5 C8.58 16.5 0.66 16.5 -7.5 16.5 C-7.5 14.52 -7.5 12.54 -7.5 10.5 C-6.012 10.008 -4.524 9.516 -3 9 C-1.164 4.476 -1.164 4.476 0 0 Z ",
    fill: "#E39936",
    transform: "translate(7.5,7.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.716 1.2515 7.278 2.148 10.594 5.7188 C10.969 9.75 10.969 9.75 10.594 13.2188 C9.604 13.2188 8.614 13.2188 7.594 13.2188 C6.6656 11.7338 5.7372 10.2488 4.7816 8.7188 C3.7294 7.2338 2.6772 5.7488 1.594 4.2188 C-0.3862 4.2188 -2.3662 4.2188 -4.4062 4.2188 C-5.3962 7.1888 -6.3862 10.1588 -7.4062 13.2188 C-8.4262 13.2188 -9.4462 13.2188 -10.4062 13.2188 C-9.9376 8.1562 -9.9376 8.1562 -8.9062 2.7188 C-4.4062 -0.2812 -4.4062 -0.2812 0 0 Z ",
    fill: "#312310",
    transform: "translate(11.9062,4.7812)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.625 1.125 8.625 1.125 12 4.5 C12.1872 8.4376 12.1872 8.4376 12 12 C10.41 12 8.82 12 7.2 12 C6.9408 9.0403 6.4436 6.0368 3 3 C2.01 2.01 1.02 1.02 0 0 Z ",
    fill: "#1A150B",
    transform: "translate(10.5,6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0 4.95 0 7.5 0 C7.005 2.475 6.51 4.95 6 7.5 C4.02 6.005 2.04 4.51 0 3 C0 4.02 0 5.04 0 6 Z ",
    fill: "#9CFA33",
    transform: "translate(7.5,10.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.25 2.0625 2.25 2.0625 4.5 4.5 C4.5 5.49 4.5 6.48 4.5 7.5 C5.49 7.5 6.48 7.5 7.5 7.5 C7.995 6.015 8.51 4.53 9 3 C9 4.92 9 6.84 9 9 C5.535 9 2.07 9 -1.5 9 C-1.005 6.03 -0.51 3.06 0 0 Z ",
    fill: "#D49131",
    transform: "translate(15,10.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrythingy);
export default __webpack_public_path__ + "static/media/entrythingy.009739ae28c582f288818990d473ff02.svg";
export { ForwardRef as ReactComponent };